<template>
<div v-if="show">
    <div class="nodata_chart" :style="{color:'rgba(0, 0, 0, 0.45)', background:'#fbfbfb', height:`${height}px`, lineHeight:`${height}px`, textAlign:'center'}"  v-if="data.length<=0">
      {{ $t('common.noData') }}
    </div>
    <v-chart :id="`chart${uuid}`" :force-fit="true" :height="height" :data="data" :padding='[0, 0, 0, 20]' :scale="chart.scale"> 
      <!-- 用于坐标轴 -->
      <v-coord type="rect" direction="LT" />
      <v-pyramid :position="`${conf.x.id}*${conf.y[0].id}`" :color="[conf.x.id, conf.y[0].color]" :opacity="0" :active="false"/>

      <v-view :data="data" :start="{x:0.21, y:0}"  :end="{x:0.85, y:1}"> 
        <v-coord type="rect" direction="LT" />
        <v-pyramid :position="`${conf.x.id}*${conf.y[0].id}`" :color="[conf.x.id, conf.y[0].color]" :opacity="0.2" :onMouseMove="mouse"/>
        <v-guide v-for="(guide, index) in chart.lines[0]" :key="index" type="html" :position="guide.position" :html="guide.html" /> 
      </v-view>

      <v-view :data="data" :start="{x:0.21, y:0}"  :end="{x:0.85, y:1}" :scale="chart.scale"> 
        <v-coord type="rect" direction="LT" />
        <v-pyramid :position="`${conf.x.id}*${conf.y[1].id}`" :color="[conf.x.id, conf.y[1].color]" :opacity="0.2" />
        <v-guide v-for="(guide, index) in chart.lines[1]" :key="index" type="html" :position="guide.position" :html="guide.html" />  
      </v-view>

      <v-guide type="html" :position="['min', 'min']" :html="`<div class='vip_left_guide vip_guide_title' style='margin-top:${chart.margin-30}px'><span>${conf.y[0].title}</span><span>占比</span></div>`"/> 
      <v-guide type="html" :position="['min', 'max']" :html="`<div class='vip_right_guide vip_guide_title' style='margin-top:${chart.margin-30}px'><span>${conf.y[1].title}</span><span>占比</span></div>`"/> 

      <v-guide v-for="(obj, index) in data" :key="`left_guide_${index}`" type="html" :position="[obj[conf.x.id], 'min']" 
        :html="`<div class='vip_left_guide' style='margin-top:${chart.margin}px'><span>${format(obj[conf.y[0].id])}</span><span>${obj[conf.y[0].ratio]?`${obj[conf.y[0].ratio]}%`:'-'}</span></div>`"/> 
      <v-guide v-for="(obj, index) in data" :key="`right_guide_${index}`" type="html" :position="[obj[conf.x.id], 'max']" 
        :html="`<div class='vip_right_guide' style='margin-top:${chart.margin}px'><span>${format(obj[conf.y[1].id])}</span><span>${obj[conf.y[1].ratio]?`${obj[conf.y[1].ratio]}%`:'-'}</span></div>`"/> 
      <v-guide v-for="(obj, index) in data" :key="`axis_${index}`" type="html" :position="[obj[conf.x.id], 'min']" 
        :html="`<div class='vip_axis_guide' style='margin-top:${chart.margin}px'>${obj[conf.x.id]}</div>`"/> 
      <v-guide type="html" :position="['max', 'median']" :html="`<div style='width:850px;height:${-chart.margin*2}px;margin:0 0 0 40px; background:#fff;'></div>`"/> 

    
    </v-chart>
    <div class="vip_chart_legend">
      <div class="vip_chart_legend_item" v-for="y in conf.y" :key="y.id">
        <span :style="{background:y.color}"></span>{{y.title}}
      </div>
    </div>
</div>
</template>

<script>
import moment from "moment"

import Vue from 'vue'
import Viser from 'viser-vue'
import { registerShape, Global } from 'viser-vue';
import {initType, initScale, initAxis, initData, initTooltip, DefaultTheme} from '@/utils/chart'
Vue.use(Viser)

export default {
    props:{
        conf: {type:Object, default:{}},
        fields: {type:Array, default:{}},
        datas: {type:Array, default:()=>[]},
        height: {type:Number, default:500},
    },
    watch: {
      datas() {
        this.show = false
        this.$nextTick(()=>{
          this.show = true
        })
      }
    },
    computed: {
      data() {
        let new_datas = []
        this.datas.forEach((row)=>{
          let flag = false
          this.conf.y.forEach((y)=>{
            if(row[y.id]) {
              flag = true
            }
          })
          if(flag) {
            new_datas.push(row)
          }
        })
        return new_datas
      },
        chart() {
            let scale = [{dataKey:this.conf.x.id, type:'cat', nice: false}]
            let nodatas = []
            this.conf.y.forEach((y)=>{
              let mmax = _.max(_.map(this.data, y.id))
              if(mmax>0) {
                scale.push({dataKey:y.id, nice: false, min:0, max:mmax})
              }
              else {
                nodatas.push(y.id)
              }
            })
            const chart_width=845
            let xs = _.uniq(_.map(this.data, this.conf.x.id))
            let height = xs.length>0?490/xs.length:0
            let guide_lines = []
            this.conf.y.forEach((y,y_index)=>{
              if(nodatas.indexOf(y.id)<0) {
                let max_y = _.max(_.map(this.data, y.id))

                let lines = []
                this.data.forEach((row, row_index)=>{
                  let width = (max_y - row[y.id])/2
                  let y_pos = 0
                  if(y_index==0) {
                    y_pos = width/2
                  } 
                  else {
                    y_pos = width*1.5 + row[y.id]
                  }
                  lines.push({position:[row[this.conf.x.id], y_pos], html:`<div class='vip_guide_line' style="border-color:${y.color}; width:${width*chart_width/max_y}px; margin-top:${-height/2}px"></div>`})
                  
                })
                guide_lines.push(lines)
              }
              else {
                guide_lines.push([])
              }
            })

            return {
                scale: scale,
                lines: guide_lines,
                margin: -height/2
            }
        },
    },
    mounted() {
        this.uuid = this.guid()
    },
    data() {
        return {
            uuid:"",
            show: true,
        }
    },
    methods: {
        guid() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0,
                    v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            })
        },
        format(value) {
          if(!value) {
            return '-'
          }
          if(!isNaN(value))
              return Math.round(value).toLocaleString()
          else
              return value
        },
        mouse() {
        }
    }
}
</script>
<style lang="less">
@import '../../../assets/less/var.less';
.vip_guide_line {
  width:100px;
  border-bottom:1px dashed #000;
}
.vip_axis_guide {
  width:50px;
  font-size:13px;
  text-align: right;
  font-weight: bold;
}
.vip_left_guide {
  width: 200px;
  margin:0 0 0 120px;
  color: #1890ff;
  font-size:13px;
  span {
    width:100px;
    text-align: right;
    display: inline-block;
  }
}
.vip_right_guide {
  width: 200px;
  margin:0 0 0 -100px;
  color: #7acb7a;
  font-size:13px;
  span {
    width:100px;
    text-align: right;
    display: inline-block;
  }
}
.vip_guide_title {
  margin-top:-40px;
}
.vip_chart_legend {
  position:relative;
  z-index:99999;
  text-align: center;
  margin:-20px 0 0 110px;
  .vip_chart_legend_item {
    display: inline-block;
    cursor:default;
    margin:0 10px;
    span {
      display: inline-block;
      height:10px;
      width:10px;
      margin:0 10px 0 0;
    }

    &.hide {
      color:#888;
      span {
        background: #888;
      }
    }
  }
}
</style>
